module.exports = __webpack_public_path__ + "static/assets/080ddeef887797104b446a13704ba442.png";